<template>
	<div id="app" class="container-fluid d-flex flex-column sticky-footer-wrapper">

		<header>
			<TopNavi :profile_name="this.$store.getters.profileGetName" />
		</header>
	
		<main role="main" class="flex-fill">
			<div v-if="this.$store.state.show_loading == 1" class="text-center gold mt-5 -pt-5">
				<img :src="this.$store.state.layout.logo" alt="iAMc" width="auto" height="35" class="m-4" /><br />
				<i class="fas fa-atom fa-spin fa-2x"></i>
			</div>
			<div v-else>
				<router-view />
			</div>
		</main>
	
		<footer v-if="this.$store.state.profile.status == 1" class="footer mt-auto py-1">
			<PageFooter />
		</footer>

	</div>
</template>

<script>

import TopNavi from './components/TopNavi.vue';
import PageFooter from './components/PageFooter.vue';


import axios from "axios";
import * as Cookie from '@/assets/js/cookie.js';




export default {
	name: 'App',
	components:{ 
		TopNavi,
		PageFooter,
	},
	data() {
		return {
			temp: '',
		}
	},
	computed: {
	},
	mounted: function() {
		console.log("HELLO:" + this.$route.meta.title);
		document.title = this.$route.meta.title + ' - iAMconnected Forum';
		this.checkLoginStatus();
		this.getCategories();		
	},
	methods:{
		checkLoginStatus() {
			console.log('checkLoginStatus');
			this.$store.state.show_loading = 1;
			if(this.$route.name == 'reset_password' || this.$route.name == 'login'){
				this.$store.state.show_loading = 0;
			} else {
				this.$store.state.session_id = Cookie.getCookie("user_session");
				if(this.$store.state.session_id == ''){
					console.log('no user---------');
					this.$router.push('/login');
				}
				else
				{
					console.log('get profile---------');
					this.getProfile();
				}
			}
		},
		
		getCategories() {
			console.log('APP: getCategories');
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);

			axios({
				url: _this.$store.state.api_url + "forum/categoriesGet",
				params: params,
			})
			.then(function(response) {
				_this.$store.commit("categoriesSet", response.data);
			})
			.catch(function() { console.log('Error: getMenu.'); });
				
		},
		
		getMenu() {
			console.log('APP: userMenuBlogGet');
			let _this = this;
			axios({
				url: _this.$store.state.api_url + "userMenuBlogGet",
				params:{
					session_id: _this.$store.state.session_id,
				}
			})
			.then(function(response) {
				if(response.data.menu.status == 1){
					_this.$store.commit("menuSet", response.data);
				}
				
			})
			.catch(function() { console.log('Error: getMenu.'); });
				
		},
		
		getProfile() {
			let _this = this;
			axios({
				url: _this.$store.state.api_url + "userGet",
				params:{
					session_id: _this.$store.state.session_id,
				}
			})
			.then(function(response) {
				console.log('getProfile - result');
				
				if(response.data.profile.status == 1){
					_this.$store.commit("profileSet", response.data);
					
					if(typeof _this.$route.meta.min_level !== 'undefined'){
						if(_this.$route.meta.min_level === 'admin'){
							
							if(response.data.profile.level < 90){
								console.log('User level not accepted');
								_this.$router.push('/');
							}
						}
					}
					
					_this.getMenu();
				}
				else if(response.data.profile.status == -5){
					if(_this.$route.name != 'login'){
						_this.$router.push('/login');
					}
				}
					
				_this.$store.state.show_loading = 0;
			})
			.catch(function() { console.log('Error: getProfile.'); });
		},
	},
	watch: {
		'$route' (to) {
			console.log("PAGE:" + to.meta.title);
			document.title = to.meta.title + ' - iAMconnected Forum';
		}
	},
}
</script>

<style scoped>
body, .sticky-footer-wrapper {
	min-height:100vh;
}

.flex-fill {
	flex:1 1 auto;
}
</style>
